import http from "./http";

//超级管理员分配课程给校区
export function put_distribution_school_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/course/school_permission" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//校长分配课程给老师
export function put_distribution_teacher_api(data) {
    return new Promise((resolve, reject) => {
      http.put("/course/teacher_permission" , data).then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
}

//审核课程 
export function put_course_approval_api(data) {
    return new Promise((resolve, reject) => {
      http.put("/course/approval" , data).then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
}

//隐藏课程
export function put_course_hidden_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/course/hidden" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
